import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema, FieldValues } from "../../../Schema";

/**
 * Whether positions within the cluster are tracked. Toggled from the cluster
 * components preview (not shown as its own input).
 *
 * Lives in `common` rather than `cluster` because a CLUSTER-SUBEQUIPMENT is an equipment
 * record and carries it too — all 1246 of them in dev — so both schemas need it.
 */
export const trackPositionInCluster: FieldSchema = {
  name: "trackPositionInCluster",
  data: {
    type: DataTypes.BOOLEAN,
    active: true,
  },
  dataTransform: {
    fromGraphql: {
      getter: ({ trackPositionInCluster }: FieldValues) => Boolean(trackPositionInCluster),
      fields: ["trackPositionInCluster"],
    },
  },
  form: {
    type: InputTypes.SWITCH,
    displayed: false,
  },
};
